export default __webpack_public_path__ + "static/media/travel-tour-driver.94959dce.png";